import { createStore } from 'vuex';
import storeConfig from './storeConfig';

export default createStore(storeConfig);
